var _mask, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAcabamentoFeed = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 156,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 172,
    height: 156
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 0h172v156H2V0z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.712 96.007l-13.079-9.682a9.827 9.827 0 01-2.124-13.569l31.503-43.78a6.67 6.67 0 00-1.274-9.045l-11.008-8.834a6.646 6.646 0 00-9.203.866l-4.956 5.76-6.814-5.83 4.938-5.76a15.63 15.63 0 0121.61-1.996l11.026 8.727a15.592 15.592 0 015.762 10.068 15.578 15.578 0 01-2.789 11.257L89.801 77.986a.829.829 0 00.177 1.131l13.079 9.717-5.345 7.173z",
    fill: "#EE8322"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M97.712 96.007l-13.079-9.682a9.827 9.827 0 01-2.124-13.569l31.503-43.78a6.67 6.67 0 00-1.274-9.045l-11.008-8.834a6.646 6.646 0 00-9.203.866l-4.956 5.76-6.814-5.83 4.938-5.76a15.63 15.63 0 0121.61-1.996l11.026 8.727a15.592 15.592 0 015.762 10.068 15.578 15.578 0 01-2.789 11.257L89.801 77.986a.829.829 0 00.177 1.131l13.079 9.717-5.345 7.173z",
    fill: "url(#paint0_linear)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M168.777 129.14l-60.44-45.17c-3.49-2.607-8.437-1.897-11.05 1.586l-2.79 3.72a7.87 7.87 0 001.59 11.03l60.439 45.169c3.49 2.608 8.437 1.898 11.05-1.585l2.789-3.72a7.87 7.87 0 00-1.588-11.03z",
    fill: "#00D38D"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.77,
    d: "M168.777 129.14l-60.44-45.17c-3.49-2.607-8.437-1.897-11.05 1.586l-2.79 3.72a7.87 7.87 0 001.59 11.03l60.439 45.169c3.49 2.608 8.437 1.898 11.05-1.585l2.789-3.72a7.87 7.87 0 00-1.588-11.03z",
    fill: "url(#paint1_linear)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M163.868 134.769c.136.364.225.744.265 1.131a3.872 3.872 0 01-.949 2.846 3.884 3.884 0 01-2.696 1.323 3.822 3.822 0 01-2.673-.848 3.87 3.87 0 002.54 2.258 3.88 3.88 0 004.482-1.933 3.86 3.86 0 00.093-3.394 3.877 3.877 0 00-1.062-1.383z",
    fill: "#079D56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M164.134 135.9a4.575 4.575 0 00-.265-1.131 3.835 3.835 0 00-2.673-.848 3.895 3.895 0 00-2.676 1.305 3.882 3.882 0 00-.97 2.812c.023.389.113.772.266 1.13a3.827 3.827 0 002.672.849 3.887 3.887 0 003.646-4.117z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.74 14.278l-4.248-8.905-3.222 3.675",
    fill: "#EE8322"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.616 12.482L4.481 90.001c-5.131 6.843-3.735 16.542 3.12 21.665l7.282 5.442c6.855 5.123 16.571 3.728 21.703-3.114L94.72 36.475c5.131-6.842 3.734-16.542-3.12-21.665l-7.282-5.442c-6.855-5.122-16.571-3.728-21.703 3.114z",
    fill: "#D7D8D6"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M62.616 12.482L4.481 90.001c-5.131 6.843-3.735 16.542 3.12 21.665l7.282 5.442c6.855 5.123 16.571 3.728 21.703-3.114L94.72 36.475c5.131-6.842 3.734-16.542-3.12-21.665l-7.282-5.442c-6.855-5.122-16.571-3.728-21.703 3.114z",
    fill: "url(#paint2_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 80.686,
    y1: 48.358,
    x2: 124.242,
    y2: 48.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE8322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#F19A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#F4B276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#F7C79B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#FAD8BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#FCE6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FDF1E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEF9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#FFFEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 92.941,
    y1: 114.699,
    x2: 171.946,
    y2: 114.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D38D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 296.68,
    y1: 1544.91,
    x2: 7268.2,
    y2: 1544.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAcabamentoFeed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/acabamentoFeed.2ff021982bb1cfed15a9b2cac448c29f.svg";